"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDashboardViewFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M3 29h26V12H3zm19-10h2v4h-2zm-4-3h2v7h-2zm-6.5 5a1.5 1.5 0 100-3v-2A3.5 3.5 0 118 19.5h2a1.5 1.5 0 001.49 1.5zM2.99 3h9v7h-9zM13.99 3h15v7h-15z" })));
}
exports.default = SvgDashboardViewFilled;
//# sourceMappingURL=DashboardViewFilled.js.map